import { render, staticRenderFns } from "./forgetPw_vn.vue?vue&type=template&id=7275860c&scoped=true&"
import script from "./forgetPw_vn.vue?vue&type=script&lang=js&"
export * from "./forgetPw_vn.vue?vue&type=script&lang=js&"
import style0 from "./forgetPw_vn.vue?vue&type=style&index=0&id=7275860c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7275860c",
  null
  
)

export default component.exports